// Ordered most-specific-first; first match wins. Derived from the route tables
// in admin/AdminRouter.tsx and session/SessionRouter.tsx plus the server-rendered
// client-portal paths (config/routes.rb).
const PAGE_NAMES: Array<[RegExp, string]> = [
  // Admin SPA
  [/^\/admin\/summary\/?$/, "admin_summary"],
  [/^\/admin\/users\/users\/\d+\/edit\/?$/, "user_edit"],
  [/^\/admin\/users\/users\/?$/, "users_index"],
  [/^\/admin\/users\/roles\/?$/, "roles_index"],
  [/^\/admin\/clients\/clients\/?$/, "clients_index"],
  [/^\/admin\/clients\/companies\/?$/, "companies_index"],
  [/^\/admin\/projects\/?$/, "projects_index"],
  [/^\/admin\/files\/?$/, "files_index"],
  [/^\/admin\/content\/tracks\/?$/, "tracks_index"],
  [/^\/admin\/content\/topics\/?$/, "topics_index"],
  [/^\/admin\/content\/findings\/\d+\/?$/, "finding_edit"],
  [/^\/admin\/content\/findings\/?$/, "findings_index"],
  [/^\/admin\/content\/tech-data-items\/?$/, "tech_data_items_index"],
  [/^\/admin\/content\/tech-data-categories\/?$/, "tech_data_categories_index"],
  [/^\/admin\/content\/themes\/?$/, "themes_index"],
  [/^\/admin\/content\/metrics\/?$/, "metrics_index"],
  [/^\/admin\/content\/value-creations\/?$/, "value_creations_index"],
  [/^\/admin\/content\/indicators\/?$/, "indicators_index"],
  [/^\/admin\/content\/tags\/?$/, "tags_index"],
  [/^\/admin\/content\/recommendations\/?$/, "recommendations_index"],
  [/^\/admin\/views\/manage-views\/?$/, "views_index"],
  [/^\/admin\/views\/manage-report-templates\/[^/]+\/?$/, "report_template_edit"],
  [/^\/admin\/views\/manage-report-templates\/?$/, "report_templates_index"],
  [/^\/admin\/reports\/\d+\/builds\/(new|\d+)\/?$/, "report_build_editor"],
  [/^\/admin\/reports\/\d+\/edit\/?$/, "report_edit"],
  [/^\/admin\/reports\/\d+\/tracks\/\d+\/?$/, "report_track_review"],
  [/^\/admin\/reports\/\d+\/ccia\/tracks\/\d+\/?$/, "report_ccia_track"],
  [/^\/admin\/reports\/\d+\/ccia\/?$/, "report_ccia"],
  [/^\/admin\/reports\/?$/, "reports_index"],
  // Session app
  [/^\/users\/sign_in\/?$/, "login"],
  [/^\/users\/m2fa\/?$/, "two_factor"],
  [/^\/users\/confirmation\/?$/, "account_confirmation"],
  [/^\/users\/password\/edit\/?$/, "password_reset"],
  [/^\/clients\/auth\/sign_in\/?$/, "client_login"],
  // Client portal (server-rendered)
  [/^\/clients\/\d+\/reports/, "client_report"],
  [/^\/clients\/\d+/, "client_dashboard"]
];

// Unknown paths fall back to the path pattern with numeric segments replaced by
// :id, so new pages still group sensibly without exploding event cardinality.
export function pageNameFor(pathname: string): string {
  for (const [pattern, name] of PAGE_NAMES) {
    if (pattern.test(pathname)) return name;
  }
  return pathname.replace(/\/\d+(?=\/|$)/g, "/:id") || "/";
}
